module.exports = __webpack_public_path__ + "static/media/item_46_2.adc7caa4.jpg";